module.exports = {
  url: "https://login.iprpraha.cz/auth/",
  realm: "org",
  clientId: "d_app_katalog_prvku1"
 }
